import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from '../../../../../assist/src/app/_shared/services/base.service';
import { OrganizationDto, OrganizationListDto, OrganizationPublicAccessKeyDto } from "../../../../../assist/src/app/organisation/models/organization";

@Injectable({
  providedIn: "root",
})
export class OrganizationService extends BaseService<OrganizationDto, OrganizationListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("PUBLIC_BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "organization");
  }


  getAccessKey(): Observable<OrganizationPublicAccessKeyDto> {
    return this.http.get<OrganizationPublicAccessKeyDto>(`${this.baseUrl }organization/withaccesskey`);
  }

}
